import { AddLocationAlt } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import clsx from 'clsx';
import React, { useCallback, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { LocationFormContext } from '../../context';
import useLocationFormDetailStyles from '../styles';
import { ClearButton } from 'components/buttons';

export const PointGeometryField: React.FunctionComponent<{
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  onClear: () => void;
  textValue: string;
  setPinActive: React.Dispatch<React.SetStateAction<boolean>>;
  isPinActive: boolean;
}> = ({ onChange, onClear, textValue, setPinActive, isPinActive }) => {
  const classes = useLocationFormDetailStyles();
  const { t } = useTranslation(['locations', 'common', 'maps']);
  const { disabled } = useContext(LocationFormContext);

  const onPinClick = useCallback(() => {
    setPinActive((prev) => !prev);
  }, [setPinActive]);

  const pinButton = useMemo(
    () => (
      <Tooltip title={isPinActive ? t('maps:disablePin') : t('maps:enablePin')}>
        <IconButton
          size='small'
          onClick={onPinClick}
          disabled={disabled}
          className={clsx(
            { [classes.button]: !isPinActive },
            { [classes.buttonActive]: isPinActive }
          )}
        >
          <AddLocationAlt />
        </IconButton>
      </Tooltip>
    ),
    [classes.button, classes.buttonActive, disabled, isPinActive, onPinClick, t]
  );

  return (
    <TextField
      onChange={onChange}
      className={classes.textField}
      placeholder={`${t('maps:addLocation')} *`}
      InputProps={{
        startAdornment: pinButton,
        endAdornment: textValue && !disabled ? <ClearButton onClick={onClear} /> : null,
      }}
      disabled={disabled}
      value={textValue}
      size='small'
    />
  );
};
